import { Lightbulb, FileText } from 'lucide-react';

import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '@/components/atoms/Tooltip';

interface ExampleKimItemProps {
  text: string;
  type: 'question' | 'draft';
  onClick: () => void;
}

export const ExampleKimItem = ({ text, type, onClick }: ExampleKimItemProps) => {
  const isQuestion = type === 'question';

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            onClick={onClick}
            className={
              `flex cursor-pointer items-center gap-2 truncate rounded-md border px-3 py-1.5 text-xs shadow-sm transition-all duration-300 ` +
              (isQuestion
                ? 'border-blue-200 bg-blue-50 text-blue-900 hover:border-blue-300 hover:bg-blue-100'
                : 'border-green-200 bg-green-50 text-green-900 hover:border-green-300 hover:bg-green-100')
            }
            style={{ minHeight: 36 }}
          >
            {isQuestion ? (
              <Lightbulb className="h-4 w-4 shrink-0 text-blue-400" />
            ) : (
              <FileText className="h-4 w-4 shrink-0 text-green-400" />
            )}
            <span className="truncate">{text}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent className="max-w-sm border-0 bg-gray-800 break-words whitespace-pre-line text-white">
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
